export const CompensationIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
        <path
            fill="#666"
            d="M4.875 3.75C3.839 3.75 3 4.59 3 5.625v6.75c0 1.036.84 1.875 1.875 1.875h8.25c1.036 0 1.875-.84 1.875-1.875v-5.25c0-1.036-.84-1.875-1.875-1.875h-7.5a.376.376 0 0 0-.375.375c0 .206.169.375.375.375h7.5c.621 0 1.125.504 1.125 1.125v5.25c0 .621-.504 1.125-1.125 1.125h-8.25a1.125 1.125 0 0 1-1.125-1.125v-6.75c0-.621.504-1.125 1.125-1.125h9a.376.376 0 0 0 .375-.375.376.376 0 0 0-.375-.375h-9ZM12 10.313a.562.562 0 1 0 0-1.125.562.562 0 0 0 0 1.124Z"
        />
    </svg>
);
